module.exports = __webpack_public_path__ + "img/profile_active.fd66b281.svg";